// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y6Zp","top":"styles_top__2Qjsb"};